// Module
var code = "<title>Customily - Sign up</title> <div ng-cloak class=\"h100\"> <vue-component name=\"AffiliateSignUp\" class=\"h100\"/> </div> ";
// Exports
module.exports = code;